import React from 'react';
import type { SortItem } from '@/stores/productsApiTypes';

export type SortOptionItem = Omit<SortItem, 'code' | 'value'>;

export interface SortOrderProps {
  items: SortItem[];
  updateSortOrder: (arge0: SortOptionItem) => void;
}

export const SortOrder = ({ items, updateSortOrder }: SortOrderProps) => {
  const handleSortOrderChange = async (e: any) => {
    e.preventDefault();
    const option = e.target.options[e.target.selectedIndex];
    if (!option) {
      return;
    }

    const item: SortOptionItem = {
      urlSet: {
        api: option.getAttribute('data-apiurl'),
        web: option.getAttribute('data-weburl')
      }
    };
    updateSortOrder(item);
  };

  const selectedCode = items.filter((item: SortItem) => item.selected)[0]?.code ?? items[0]?.code;

  return (
    <>
      <select
        className="form-control custom-control custom-select"
        defaultValue={selectedCode}
        onChange={handleSortOrderChange}
        data-testid="catalog:sort-order"
      >
        {items.map((item: SortItem) => {
          return (
            <option value={item.code} data-weburl={item.urlSet?.web} data-apiurl={item.urlSet?.api} key={item.code}>
              {item.value}
            </option>
          );
        })}
      </select>
    </>
  );
};
